import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";

import { useAppSelector } from "@/reduxHooks";

export const WfConfirmationModal = () => {
  const {
    primaryAction,
    secondaryAction,
    title,
    message,
    primaryActionText,
    secondaryActionText,
  } = useAppSelector((state) => state.rootReducer.modals).modalProps;

  const onClose = () => {
    secondaryAction();
  };

  const handleDelete = () => {
    primaryAction();
  };

  return (
    <Modal isCentered isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent className="!w-[80vw]">
        <ModalHeader className="flex gap-3 items-start justify-between border-b !ml-0 !pb-3 !pl-5">
          <Box className="w-fit text-lg text-gray-800 font-semibold break-all">
            {title}
          </Box>
          <ModalCloseButton className="!relative !top-0 !right-0" />
        </ModalHeader>
        <ModalBody className="!px-4 py-3">
          <Flex className="flex-col gap-4">{message}</Flex>
          <Flex className="items-center justify-end gap-2">
            <Button colorScheme="dark" onClick={onClose} variant={"outline"}>
              {secondaryActionText}
            </Button>
            <Button colorScheme="customRed" onClick={handleDelete}>
              {primaryActionText}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
